export default "__VITE_ASSET__732bf485__"